// Client-side mirror of app/services/submission_row_filter.rb — keep both in sync.

const BLOCKED_PLACE_OF_SERVICE_CODES = new Set([
  "5",
  "6",
  "7",
  "8",
  "9",
  "05",
  "06",
  "07",
  "08",
  "09",
  "26",
]);

const BLOCKED_HCPCS_CODES = new Set([
  "G9256",
  "G9260",
  "G9262",
  "G9433",
  "G9812",
  "G9814",
  "G9816",
]);

const BLOCKED_DIAGNOSIS_CODES = new Set([
  "R45850",
  "R45851",
  "R99",
  "Z6841",
  "Z6842",
  "Z6843",
  "Z6844",
  "Z6845",
]);

const BLOCKED_DIAGNOSIS_CODE_PREFIXES = [
  "P",
  "T1491",
  "T71",
  "T742",
  "T745",
  "T750",
  "T751",
  "T762",
  "T765",
  "V",
  "X52",
  "Y35",
  "Y36",
  "Y37",
  "Y38",
  "Z38",
  "W65",
  "W66",
  "W67",
  "W68",
  "W69",
  "W70",
  "W71",
  "W72",
  "W73",
  "W74",
  "X71",
  "X72",
  "X73",
  "X74",
  "X75",
  "X76",
  "X77",
  "X78",
  "X79",
  "X80",
  "X81",
  "X82",
  "X83",
  "X92",
  "X93",
  "X94",
  "X95",
  "X96",
  "X97",
  "X98",
  "X99",
  "Y00",
  "Y01",
  "Y02",
  "Y03",
  "Y04",
  "Y05",
  "Y06",
  "Y07",
  "Y08",
  "Y09",
];

export const ENCOUNTER_DIAGNOSIS_CODE_FIELDS = [
  "encounter_diagnosis_code_primary",
  "encounter_diagnosis_code_2",
  "encounter_diagnosis_code_3",
  "encounter_diagnosis_code_4",
  "encounter_diagnosis_code_5",
  "encounter_diagnosis_code_6",
  "encounter_diagnosis_code_7",
  "encounter_diagnosis_code_8",
  "encounter_diagnosis_code_9",
  "encounter_diagnosis_code_10",
];

export const isBlockedPlaceOfService = (value) =>
  BLOCKED_PLACE_OF_SERVICE_CODES.has((value ?? "").trim());

export const isBlockedHcpcsCode = (value) => BLOCKED_HCPCS_CODES.has((value ?? "").trim());

export const isBlockedDiagnosisCode = (value) => {
  const normalized = (value ?? "").trim().replace(/\./g, "");
  if (!normalized) return false;

  return (
    BLOCKED_DIAGNOSIS_CODES.has(normalized) ||
    BLOCKED_DIAGNOSIS_CODE_PREFIXES.some((prefix) => normalized.startsWith(prefix))
  );
};
